import CompanyGeneral from './companyGeneral'
import FilterMenu from './filterMenu'
import { useSelector } from 'react-redux'
import { Analytics } from '../../../reducers/analyticsReducer'

export default function CompanyInfo() {
  const analytics = useSelector(Analytics.selectors.getAnalytics)

  return (
    <>
      <main className=" pb-8">
        <div className="mx-auto max-w-3xl lg:max-w-[1500px]">
          <h1 className="sr-only">{analytics.providerLogin} dashboard</h1>
          {/* Main 3 column grid */}
          <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-7 lg:gap-8">
            {/* Left column */}
            <div className="row-span-3 grid min-h-max grid-cols-1 gap-4 self-stretch lg:col-span-4">
              <CompanyGeneral />
            </div>

            {/* Right column */}
            <div className="row-span-3 grid grid-cols-1 gap-4 lg:col-span-3">
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">
                  Section title
                </h2>
                <div className="contents overflow-hidden rounded-lg bg-white shadow ">
                  <div className="rounded-lg bg-white p-5 shadow">
                    <FilterMenu />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
